import React from "react";

import { Button } from "ii-ui-kit";

import "./index.scss";

/** Ошибка "Время ожидания истекло "*/

interface ITimeExpiredProps {
  title: string;
}

export const TimeExpired: React.FC<ITimeExpiredProps> = ({ title }) => {
  const goToMain = () => {
    if (window.loginRestartFlowUrl) {
      window.location.replace(window.loginRestartFlowUrl);
    }
  };

  return (
    <div className="time-expired">
      <div className="time-expired__img" />
      <div className="time-expired__title">{title}</div>
      <Button
        className={"time-expired__button"}
        title={"Повторить вход"}
        size={"l"}
        onClick={goToMain}
      />
    </div>
  );
};
